import {
	getProfileAPI,
	updatedAvatarAPI,
	updatedPasswordAPI,
	getBindListAPI,
	unBindListPlatformAPI,
} from '@/api/personal-center'
import storage from '../../utils/storage'
const personalCenter = {
	namespaced: true,
	state: () => ({
		profileData: {},
	}),
	mutations: {
		setProfileData(state, profile) {
			state.profileData = profile
		},
	},
	actions: {
		/* 获取个人中心资料 */
		async fetchProfile({ commit }) {
			const res = await getProfileAPI()
			// 处理是否存在未完成添加站点步骤的逻辑
			commit('setProfileData', res.data)
			return res.data
		},
		/* 修改头像 */
		async fetchUpdateAvatar({ commit }, data) {
			const res = await updatedAvatarAPI(data)
			return res
		},
		/* 修改密码 */
		async fetchUpdatePassword({ commit }, data) {
			const res = await updatedPasswordAPI(data)
			return res
		},
		/* 第三方登录绑定详情 */
		async fetchBindList({ commit }) {
			const res = await getBindListAPI()
			return res
		},
		/* 解除绑定第三方平台 */
		async fetchUnBindPlatform({ commit }, data) {
			const res = await unBindListPlatformAPI(data)
			return res
		},
	},
}

export default personalCenter

